import types from '~/redux/constants';
export function feInitialState() {
    return {
        errorTryAgain: true,
        userServiceFail: undefined,
    };
}
export function feState(state, action) {
    switch (action.type) {
        case types.appState.SET_ERROR_TRY_AGAIN:
            return Object.assign(Object.assign({}, state), { errorTryAgain: action.payload.errorTryAgain });
        default:
            return state;
    }
}
